import { ApiService } from "@/services/api/ApiService";

export interface VisitorLeadInput {
  email: string;
  agent_id: string;
  name?: string;
  phone?: string;
  /** Which ask captured it: in_conversation, wrap_up, welcome_screen, summary_chip... */
  source: string;
  conversation_id?: string;
  page_url?: string;
}

/**
 * Saves a visitor's email from a genie page. Goes through the API's public
 * `visitor-leads` action, never a direct `leads` insert: the table's security
 * rules refuse anonymous inserts, which is why these forms failed for every
 * visitor who was not signed in to Help Genie. Throws on failure.
 */
export class VisitorLeadService {
  static async capture(input: VisitorLeadInput): Promise<void> {
    await ApiService.invoke({ resource: "visitor-leads", action: "capture", data: input }, "public");
  }
}
